import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { EventTypes } from '../../shared/EventTypes';

import { PaymentFederalTaxes } from './models/payment-federal-taxes';

import { PaymentFederalTaxesEventType } from './payment-federal-taxes.event.type';

@Component({
	selector: 'app-payment-federal-taxes',
	templateUrl: './payment-federal-taxes.component.html',
	styleUrls: ['./payment-federal-taxes.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PaymentFederalTaxesComponent implements OnInit, OnDestroy {

	paymentData = new PaymentFederalTaxes();

	activeBackButton = false;
	flowIndex = 0;
	hasSubmited = false;
	form: FormGroup;
	showBalance = false;

	title = [
		'Pagamento de Tributos Federais',
		'Pagamento de Tributos Federais',
		'Resumo de Pagamento de Tributos Federais'
	];

	subtitle = [
		'Pagamento de Impostos, Tributos e Contribuições Previdenciarias',
		'Pagamento de Impostos, Tributos e Contribuições Previdenciarias',
		'Pagamento de Impostos, Tributos e Contribuições Previdenciarias'
	];

	constructor() { }

	ngOnInit() {
		TweenMax.delayedCall(.3, () => {
			this.show();
		});
		/**
		 * Faz a troca de botões ao chegar no final dos passos.
		 */
		AppEventDispatcher.listen(PaymentFederalTaxesEventType.BUTTONS, data => {

			TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				});
			});

		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener( PaymentFederalTaxesEventType.BUTTONS );
	}

	onSetTitleSubtitle(data) {
		this.title[this.flowIndex] = data.title;
		this.subtitle[this.flowIndex] = data.subtitle;
	}

	onSetForm(form: FormGroup) {
		this.form = form;
	}

	show() {
		AppEventDispatcher.dispatch(EventTypes.BALANCE, {show: true});
		AppEventDispatcher.dispatch(PaymentFederalTaxesEventType.STEPS.PAYMENT_SELECT_STEP, { show: true });
	}

	sendForm() {
		AppEventDispatcher.dispatch(PaymentFederalTaxesEventType.PAYMENT_FEDERAL_TAXES_SEND, null);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/payment-federal-taxes.component.ts